import { create } from 'zustand';

function readPersisted(key: string, fallback: string | null): string | null {
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}

interface ProjectState {
  activeProjectId: string | null;
  setActiveProject: (id: string | null) => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
  activeProjectId: readPersisted('active_project_id', null),
  setActiveProject: (id: string | null) => {
    try {
      if (id) {
        localStorage.setItem('active_project_id', id);
      } else {
        localStorage.removeItem('active_project_id');
      }
    } catch {
      /* ignore */
    }
    set({ activeProjectId: id });
  },
}));
